import {PeriodKind} from './ModelContracts';

export class Transcript {
	static transcriptKind = (kind: PeriodKind) => {
		if (kind === 'D') return 'Daily';
		if (kind === 'W') return 'Weekly';
		if (kind === 'M') return 'Monthly';
	};
}
